export default "__VITE_ASSET__ByMdNklv__"